import { format, parseISO } from 'date-fns';

export const custheme = {
    scheme: 'white',
    base00: 'white',
    base01: 'white',
    base02: "#5555",
    base0B: 'black',
    base0D: 'black',
    nestedNodeLabel: ({ style }, keyPath, nodeType, expanded) => ({
        style: {
            ...style,
            textTransform: expanded ? 'uppercase' : style.textTransform,
        },
    }),
};

export const formatDate = (date) => {
    const startDate = parseISO(date);
    const formattedDate = format(startDate, 'yyyy-MM-dd HH:mm');
    return formattedDate
}

export const encounter = (date, text) => {
    const startDate = parseISO(date);
    const monthDay = format(startDate, 'MMM do');
    const formattedText = `${monthDay} ${format(startDate, 'yyyy')} for ${text}`;
    return formattedText;
}

export const extractDiv = (div) => {
    const regex = /<div[^>]*>([^<]+)<\/div>/g;
    const matches = div.match(regex);
    const extractedNodes = matches?.map(match => match.replace(/<\/?div[^>]*>/g, ''));
    const combinedText = extractedNodes?.join('\n');
    return combinedText;
}


export const getObservationMap = (objects) => {
    const requiredObservation = objects.reduce((map, item) => {
        const observation = item.resource.code.text
        if (!map.has(observation)) {
            map.set(observation, [])
        }
        map.get(observation).push(item)
        return map;
    }, new Map())
    return requiredObservation
}



export function getEncountersWithDiagnosis(conditions, encounters) {
    const conditionMap = new Map();

    // Step 1: Build a map of condition IDs and encounters
    for (const condition of conditions) {
        const conditionId = condition.objects[0].resource.id;
        const conditionType = condition.conditionType;
        conditionMap.set(conditionId, { name: conditionType, encounters: [] });
    }

    // Step 2: Populate encounters for each condition
    for (const encounter of encounters) {
        const diagnosis = encounter.resource.diagnosis;
        for (const diagnosisItem of diagnosis) {
            const conditionId = diagnosisItem.condition.reference.split('/')[1];
            if (conditionMap.has(conditionId)) {
                conditionMap.get(conditionId).encounters.push(encounter.resource);
            }
        }
    }

    // Step 3: Sort encounters within each condition by start period
    // eslint-disable-next-line
    for (const [conditionId, condition] of conditionMap) {
        condition.encounters.sort((a, b) => new Date(a.period.start) - new Date(b.period.start));
    }

    // Step 4: Flatten the condition map into an array with multiple objects for each encounter
    const result = [];
    // eslint-disable-next-line
    for (const [conditionId, condition] of conditionMap) {
        const { name, encounters } = condition;
        for (const encounter of encounters) {
            result.push({ name, encounter });
        }
    }

    // Step 5: Sort the result array by start period date
    result.sort((a, b) => new Date(a.encounter.period.start) - new Date(b.encounter.period.start));

    // Step 6: Return the resulting array
    return result;
}


export const filterOptions = [
    {
        label: "All Condition Encounters",
        value: "all"
    },
    {
        label: "ConditionWise Encounter",
        value: "condition"
    }
]



export const mockValidationError = {
    "resourceType": "OperationOutcome",
    "issue": [
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'Patient'"
            },
            "expression": [
                "Bundle.entry[0].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'Condition'"
            },
            "expression": [
                "Bundle.entry[1].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'Condition'"
            },
            "expression": [
                "Bundle.entry[2].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'Condition'"
            },
            "expression": [
                "Bundle.entry[3].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'Condition'"
            },
            "expression": [
                "Bundle.entry[4].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'Condition'"
            },
            "expression": [
                "Bundle.entry[5].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'Condition'"
            },
            "expression": [
                "Bundle.entry[6].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'Condition'"
            },
            "expression": [
                "Bundle.entry[7].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'Condition'"
            },
            "expression": [
                "Bundle.entry[8].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'Condition'"
            },
            "expression": [
                "Bundle.entry[9].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'Condition'"
            },
            "expression": [
                "Bundle.entry[10].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'Condition'"
            },
            "expression": [
                "Bundle.entry[11].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'AllergyIntolerance'"
            },
            "expression": [
                "Bundle.entry[12].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'AllergyIntolerance'"
            },
            "expression": [
                "Bundle.entry[13].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'MedicationStatement'"
            },
            "expression": [
                "Bundle.entry[14].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'Medication'"
            },
            "expression": [
                "Bundle.entry[15].resource.contained[0]"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'MedicationStatement'"
            },
            "expression": [
                "Bundle.entry[15].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'MedicationStatement'"
            },
            "expression": [
                "Bundle.entry[16].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'MedicationStatement'"
            },
            "expression": [
                "Bundle.entry[17].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'MedicationStatement'"
            },
            "expression": [
                "Bundle.entry[18].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'MedicationStatement'"
            },
            "expression": [
                "Bundle.entry[19].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'MedicationStatement'"
            },
            "expression": [
                "Bundle.entry[20].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'MedicationStatement'"
            },
            "expression": [
                "Bundle.entry[21].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'MedicationStatement'"
            },
            "expression": [
                "Bundle.entry[22].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'MedicationStatement'"
            },
            "expression": [
                "Bundle.entry[23].resource"
            ]
        },
        {
            "severity": "error",
            "code": "invalid",
            "diagnostics": "<HSFHIRErr>UnexpectedPropertyName",
            "details": {
                "text": "The property name 'iddds' is not valid for type 'MedicationStatement'"
            },
            "expression": [
                "Bundle.entry[24].resource"
            ]
        },
        {
            "severity": "error",
            "code": "exception",
            "diagnostics": "5017",
            "details": {
                "text": "Too many errors"
            }
        }
    ]
}


export const isKeyPresentInData = (keyName, wholeData) => {
    console.log("keyName", wholeData)
    const isKeyPresent = wholeData.find((item) => item.resourceType === keyName)
    if (isKeyPresent) return true
    return false
}


export const filteredObjects = (data) => {
    const filteredObjects = data.filter(item => {
        if ("valueQuantity" in item.objects[0].resource) {
            const valueQuantity = item.objects[0].resource.valueQuantity;
            return valueQuantity && "value" in valueQuantity;
        }
        return false;
    });
    // Print the filtered objects
    return filteredObjects;
};
